export const generateHash = () =>
	`_${Math.random()
		.toString(36)
		.substr(2, 9)}${new Date().getTime()}`;
